import React from 'react';
import './index.scss';

class AnyGuideHeader extends React.Component {
  static displayName = 'AnyGuideHeader';

  render() {
    return (
      <div className="AnyGuideHeader-wrapper">
        <div className="AnyGuideHeader-logo-wrapper">
          <img
            src={require('views/anyguide_bookings/header/logo.png')}
            className="AnyGuideHeader-logo"
          />
        </div>
      </div>
    );
  }
}

export default AnyGuideHeader;
